import React from "react"

const Placeholder = ({ type, placeholder }) => {
  const createMark = type => ({
    type: "node-placeholder",
    data: { type }
  })

  return {
    decorateNode(node, editor, next) {
      if (node.type !== type) return next()
      if (node.text !== "") return next()
      const others = next()
      const first = node.getFirstText()
      const last = node.getLastText()

      const decoration = {
        anchor: { key: first?.key, offset: 0 },
        focus: { key: last?.key, offset: last?.text?.length },
        mark: createMark(type)
      }

      return [...others, decoration]
    },
    renderMark(props, editor, next) {
      const { children, mark } = props

      if (mark.type !== "node-placeholder") return next()
      if (mark.data.get("type") !== type) return next()

      const style = {
        pointerEvents: "none",
        height: "0",
        maxWidth: "100%",
        whiteSpace: "nowrap",
        opacity: "0.4",
        padding: 0
      }

      return (
        <div style={{ padding: 0 }}>
          <div contentEditable={false} style={style}>
            {typeof placeholder == "function" ? placeholder() : placeholder}
          </div>
          {children}
        </div>
      )
    }
  }
}

export default ({ type, placeholder }) => Placeholder({ type, placeholder })
